import slickLazy from '../utils/slickLazy';

export default () => {
  const $slider = $('.services');

  if ($slider.length === 0) {
    return;
  }

  slickLazy($slider);

  $slider.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
};
